//首页
const home = () => import('@/views/home');


const routes = [
    {
	    path: '/',
	    name: "home",
	    component: home,
	    meta: {
	        title: '四川大学继续教育学院自学考试'
	    }
	}
]
export default routes;